import './feedback-types.css'

import React, { Component } from 'react'

import TextField from '../../../components/TextField'

class FeedbackText extends Component {
  render() {
    const { label, value = '', onChange, id, inputProps } = this.props
    return (
      <div className="Feedback-question">
        <label htmlFor={id} className="Feedback-label">
          {label}
        </label>
        <TextField
          id={id}
          fullWidth={true}
          value={value}
          onChange={onChange}
          {...inputProps}
        />
      </div>
    )
  }
}

export default FeedbackText



// WEBPACK FOOTER //
// ./src/addons/feedback/types/Text.js